import { ScrollCarousel, Player } from 'theme';

/**
 * Product offers carousel with optional autoplay (loops), mouse drag via allow-drag,
 * and centered inline-dots alignment (dots + icon + text).
 */
class ProductOffersCarousel extends ScrollCarousel {
  connectedCallback() {
    super.connectedCallback();

    this._offersRoot = this.closest('.product-offers');
    this._dotsAligner = this._offersRoot?.querySelector('.product-offers__dots-aligner');
    this._contentGhost = this._dotsAligner?.querySelector('.product-offers__content-ghost');
    this._pageDots = this._offersRoot?.querySelector('.page-dots');

    if (this._dotsAligner && this._contentGhost) {
      this._syncInlineDotsAlignment = this._syncInlineDotsAlignment.bind(this);
      this.addEventListener('carousel:change', this._syncInlineDotsAlignment);
      this.addEventListener('carousel:settle', this._syncInlineDotsAlignment);
      window.addEventListener('resize', this._syncInlineDotsAlignment);
      requestAnimationFrame(() => this._syncInlineDotsAlignment());
    }

    if (!this.hasAttribute('autoplay') || this.cells.length <= 1) {
      return;
    }

    this._player = new Player(this.getAttribute('autoplay') || 5);
    this._player.addEventListener('player:end', () => {
      const nextIndex = (this.selectedIndex + 1) % this.cells.length;
      this.select(nextIndex);
    });

    this.addEventListener('carousel:settle', () => {
      this._player?.start();
    });

    this.addEventListener('mousedown', () => this._player?.pause());
    this.addEventListener('touchstart', () => this._player?.pause(), { passive: true });
    this.addEventListener('mouseenter', () => this._player?.pause());
    this.addEventListener('mouseleave', () => this._player?.start());

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', () => this._player?.stop());
      this.addEventListener('shopify:block:deselect', () => this._player?.start());
    }

    this._player.start();
  }

  disconnectedCallback() {
    if (typeof super.disconnectedCallback === 'function') {
      super.disconnectedCallback();
    }

    if (this._syncInlineDotsAlignment) {
      window.removeEventListener('resize', this._syncInlineDotsAlignment);
    }

    this._player?.stop();
  }

  _syncInlineDotsAlignment() {
    if (!this._offersRoot || !this._contentGhost || !this._pageDots) {
      return;
    }

    const activeContent = this.selectedCell?.querySelector('.product-offers__content');
    if (!activeContent) {
      return;
    }

    this._contentGhost.innerHTML = activeContent.innerHTML;
    this._offersRoot.style.setProperty('--product-offers-dots-width', `${this._pageDots.offsetWidth}px`);
  }
}

if (!window.customElements.get('product-offers-carousel')) {
  window.customElements.define('product-offers-carousel', ProductOffersCarousel);
}
